var _excluded = ["children", "theme", "textColor", "bgColor"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { node, string } from 'prop-types';
import { withTheme } from 'styled-components';
import { Span } from './style';
var Tag = function Tag(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    textColor = _ref.textColor,
    bgColor = _ref.bgColor,
    rest = _objectWithoutProperties(_ref, _excluded);
  var tagTextColor = textColor || theme.colors.text.inverted;
  var tagBgColor = bgColor || theme.colors.background.primary;
  return /*#__PURE__*/React.createElement(Span, _extends({
    textColor: tagTextColor,
    bgColor: tagBgColor
  }, rest), children);
};
Tag.defaultProps = {
  textColor: null,
  bgColor: null,
  className: ''
};
Tag.propTypes = {
  children: node.isRequired,
  textColor: string,
  bgColor: string,
  className: string
};
export default withTheme(Tag);